"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.profession.select.label': 'Wybierz swój zawód, aby rozpocząć onboarding:',
    'onboarding.profession.select.placeholder': '-- Wybierz Zawód --',
    'onboarding.profession.empty': 'Brak dostępnych zawodów.',
};
